var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.isShowContent,
          expression: "isShowContent",
        },
      ],
      ref: "scrollMain",
      class: [_vm.language == "en" ? "en" : "", "app-container-sitc"],
      staticStyle: { "padding-bottom": "0px", "padding-top": "0px" },
    },
    [
      _c(
        "div",
        {
          staticClass: "container-content filter-container-content",
          staticStyle: {
            height: "48px",
            display: "flex",
            "align-items": "center",
          },
        },
        [
          _vm._l(_vm.navTabList, function (item, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "tab_text",
                class: { selected: _vm.selectedIndex === index },
                on: {
                  click: function ($event) {
                    return _vm.selectTab(index)
                  },
                },
              },
              [
                _vm._v(
                  "\n         " +
                    _vm._s(_vm.language === "zh" ? item.name : item.nameEn) +
                    "\n         "
                ),
                index < 4
                  ? _c("div", { staticClass: "tab_text_border" })
                  : _vm._e(),
              ]
            )
          }),
          _vm._v(" "),
          _vm.form.status
            ? _c("bookingStatus", {
                staticClass: "main-status",
                attrs: {
                  bookingList: _vm.bookingStatusList,
                  status: Number(_vm.form.status),
                },
              })
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "el-form",
        {
          ref: "form",
          staticStyle: { "padding-bottom": "50px", "margin-top": "60px" },
          attrs: {
            rules: _vm.rules,
            "label-position": "top",
            model: _vm.form,
            disabled: _vm.isDisable,
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "filter-container-content",
              attrs: { id: "basicInfo" },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 14 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("home.vesselAndVoyage") } },
                        [
                          _c("el-input", {
                            directives: [
                              {
                                name: "byte-length",
                                rawName: "v-byte-length",
                                value: 50,
                                expression: "50",
                              },
                            ],
                            attrs: { disabled: true },
                            model: {
                              value: _vm.vessNameVoy,
                              callback: function ($$v) {
                                _vm.vessNameVoy = $$v
                              },
                              expression: "vessNameVoy",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "saillingDate",
                            label: _vm.$t("home.sailingTime"),
                          },
                        },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              "picker-options": _vm.pickerOptions,
                              type: "date",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm",
                              placeholder: "",
                              disabled: true,
                            },
                            model: {
                              value: _vm.form.saillingDate,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "saillingDate", $$v)
                              },
                              expression: "form.saillingDate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "eta",
                            label: _vm.$t("home.arrivalTime"),
                          },
                        },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              "picker-options": _vm.pickerOptions,
                              disabled: true,
                              type: "date",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm",
                              placeholder: "",
                            },
                            model: {
                              value: _vm.form.eta,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "eta", $$v)
                              },
                              expression: "form.eta",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.isOriginTemplate ||
                  _vm.isCopy == "copy" ||
                  (!_vm.form.status && _vm.form.status == 11)
                    ? _c(
                        "el-col",
                        {
                          staticStyle: { "margin-top": "28px" },
                          attrs: { span: 6 },
                        },
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "btn-primary",
                              staticStyle: {
                                width: "100%",
                                "font-size": "14px",
                              },
                              attrs: { type: "btn-primary", plain: "" },
                              on: { click: _vm.handleSelectVessel },
                            },
                            [_vm._v(_vm._s(_vm.$t("home.selectVesselTime")))]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 14 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "bookingFwdPerson",
                            label: _vm.$t("home.contactCustomer"),
                          },
                        },
                        [
                          _c("el-input", {
                            directives: [
                              {
                                name: "byte-length",
                                rawName: "v-byte-length",
                                value: 50,
                                expression: "50",
                              },
                              { name: "uppercase", rawName: "v-uppercase" },
                              { name: "trim", rawName: "v-trim" },
                              { name: "fth", rawName: "v-fth" },
                            ],
                            attrs: {
                              title: "",
                              onblur: "this.value = this.value.toUpperCase()",
                              disabled: _vm.preLockFlag,
                            },
                            model: {
                              value: _vm.form.bookingFwdPerson,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "bookingFwdPerson", $$v)
                              },
                              expression: "form.bookingFwdPerson",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "bookingFwdTel",
                            label: _vm.$t("home.mobilePhone"),
                          },
                        },
                        [
                          _c("el-input", {
                            directives: [
                              {
                                name: "byte-length",
                                rawName: "v-byte-length",
                                value: 50,
                                expression: "50",
                              },
                              { name: "uppercase", rawName: "v-uppercase" },
                              { name: "trim", rawName: "v-trim" },
                              { name: "fth", rawName: "v-fth" },
                            ],
                            attrs: {
                              onblur: "this.value = this.value.toUpperCase()",
                              disabled: _vm.preLockFlag,
                            },
                            model: {
                              value: _vm.form.bookingFwdTel,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "bookingFwdTel", $$v)
                              },
                              expression: "form.bookingFwdTel",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "bookingFwdEmail",
                            label: _vm.$t("home.emailPlus"),
                          },
                        },
                        [
                          _c("el-input", {
                            directives: [
                              {
                                name: "byte-length",
                                rawName: "v-byte-length",
                                value: 50,
                                expression: "50",
                              },
                              { name: "uppercase", rawName: "v-uppercase" },
                              { name: "trim", rawName: "v-trim" },
                              { name: "fth", rawName: "v-fth" },
                            ],
                            attrs: {
                              onblur: "this.value = this.value.toUpperCase()",
                              disabled: _vm.preLockFlag,
                            },
                            model: {
                              value: _vm.form.bookingFwdEmail,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "bookingFwdEmail", $$v)
                              },
                              expression: "form.bookingFwdEmail",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          class: {
                            reqired:
                              _vm.form.pol && _vm.form.pol.startsWith("TH"),
                          },
                          attrs: {
                            prop: "actualShipper",
                            label: _vm.$t("home.people"),
                          },
                        },
                        [
                          _c("el-input", {
                            directives: [
                              {
                                name: "byte-length",
                                rawName: "v-byte-length",
                                value: 100,
                                expression: "100",
                              },
                              { name: "uppercase", rawName: "v-uppercase" },
                              { name: "trim", rawName: "v-trim" },
                              { name: "fth", rawName: "v-fth" },
                            ],
                            attrs: {
                              onblur: "this.value = this.value.toUpperCase()",
                              disabled: _vm.preLockFlag,
                            },
                            model: {
                              value: _vm.form.actualShipper,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "actualShipper", $$v)
                              },
                              expression: "form.actualShipper ",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 14 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          class: { reqired: !_vm.hasBkNoRules },
                          attrs: { prop: "bkNo", label: _vm.$t("home.bkNo") },
                        },
                        [
                          _c("el-input", {
                            directives: [
                              { name: "uppercase", rawName: "v-uppercase" },
                              { name: "trim", rawName: "v-trim" },
                              { name: "fth", rawName: "v-fth" },
                              {
                                name: "byte-length",
                                rawName: "v-byte-length",
                                value: 20,
                                expression: "20",
                              },
                            ],
                            attrs: { disabled: _vm.hasBkNoRules },
                            on: {
                              input: function ($event) {
                                _vm.form.bkNo = _vm.form.bkNo
                                  .replace(/[^\a-\z\A-\Z0-9\*\.]/g, "")
                                  .toUpperCase()
                              },
                            },
                            model: {
                              value: _vm.form.bkNo,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "bkNo", $$v)
                              },
                              expression: "form.bkNo",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          class: { reqired: !_vm.hasBlNoRules },
                          attrs: { prop: "blNo", label: _vm.$t("home.blNo") },
                        },
                        [
                          _c("el-input", {
                            directives: [
                              { name: "uppercase", rawName: "v-uppercase" },
                              { name: "trim", rawName: "v-trim" },
                              { name: "fth", rawName: "v-fth" },
                              {
                                name: "byte-length",
                                rawName: "v-byte-length",
                                value: 50,
                                expression: "50",
                              },
                            ],
                            attrs: { disabled: _vm.hasBlNoRules },
                            on: {
                              input: function ($event) {
                                _vm.form.blNo = _vm.form.blNo
                                  .replace(/[^\a-\z\A-\Z0-9\*\.]/g, "")
                                  .toUpperCase()
                              },
                            },
                            model: {
                              value: _vm.form.blNo,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "blNo", $$v)
                              },
                              expression: "form.blNo",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "bookingType",
                            label: _vm.$t("home.bookingType"),
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                clearable: "",
                                disabled: _vm.preLockFlag,
                              },
                              model: {
                                value: _vm.form.bookingType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "bookingType", $$v)
                                },
                                expression: "form.bookingType",
                              },
                            },
                            _vm._l(_vm.bookingTypeList, function (item) {
                              return _c("el-option", {
                                key: item.codeValue,
                                attrs: {
                                  label:
                                    _vm.language === "zh"
                                      ? item.displayValueCn
                                      : item.displayValue,
                                  value: Number(item.codeValue),
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "reqired",
                          attrs: {
                            prop: "transportationTerms",
                            label: _vm.$t("home.transportationTerms"),
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                clearable: "",
                                disabled: _vm.preLockFlag,
                              },
                              model: {
                                value: _vm.form.transportationTerms,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "transportationTerms", $$v)
                                },
                                expression: "form.transportationTerms",
                              },
                            },
                            _vm._l(
                              _vm.transportationTermsList,
                              function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: { label: String(item), value: item },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 14 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          class: {
                            reqired:
                              _vm.form.pol == "CNSHK" ||
                              _vm.form.pol == "CNNSA",
                          },
                          attrs: {
                            prop: "paidPalce",
                            label: _vm.$t("home.paidPalce"),
                          },
                        },
                        [
                          _c("glPort", {
                            attrs: {
                              disabled:
                                _vm.preLockFlag || _vm.form.pol === "CNTAO",
                            },
                            model: {
                              value: _vm.form.paidPalce,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "paidPalce", $$v)
                              },
                              expression: "form.paidPalce",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "reqired",
                          attrs: {
                            prop: "paidType",
                            label: _vm.$t("home.paidType"),
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                clearable: "",
                                disabled: _vm.preLockFlag,
                              },
                              model: {
                                value: _vm.form.paidType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "paidType", $$v)
                                },
                                expression: "form.paidType",
                              },
                            },
                            _vm._l(_vm.paidTypeList, function (item) {
                              return _c("el-option", {
                                key: item.codeValue,
                                attrs: {
                                  label:
                                    _vm.language === "zh"
                                      ? item.displayValueCn
                                      : item.displayValue,
                                  value: Number(item.codeValue),
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "reqired",
                          attrs: {
                            prop: "deliveryDocumentMethod",
                            label: _vm.$t("home.documentType"),
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                disabled:
                                  _vm.preLockFlag ||
                                  (_vm.form.pol &&
                                    _vm.form.pol.startsWith("TH")) ||
                                  (_vm.form.pol &&
                                    _vm.form.pol.startsWith("KR")),
                              },
                              model: {
                                value: _vm.form.deliveryDocumentMethod,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "deliveryDocumentMethod",
                                    $$v
                                  )
                                },
                                expression: "form.deliveryDocumentMethod",
                              },
                            },
                            _vm._l(_vm.documentTypeList, function (item) {
                              return _c("el-option", {
                                key: item.codeValue,
                                attrs: {
                                  label:
                                    _vm.language === "zh"
                                      ? item.displayValueCn
                                      : item.displayValue,
                                  value: Number(item.codeValue),
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          class: {
                            reqired: _vm.form.deliveryDocumentMethod == "2",
                          },
                          attrs: {
                            prop: "wbillNo",
                            label: _vm.$t("home.documentNo"),
                          },
                        },
                        [
                          _c("el-input", {
                            directives: [
                              { name: "uppercase", rawName: "v-uppercase" },
                              { name: "trim", rawName: "v-trim" },
                              { name: "fth", rawName: "v-fth" },
                              {
                                name: "byte-length",
                                rawName: "v-byte-length",
                                value: 50,
                                expression: "50",
                              },
                            ],
                            attrs: {
                              disabled:
                                _vm.form.deliveryDocumentMethod == "1" ||
                                _vm.preLockFlag,
                              onblur: "this.value = this.value.toUpperCase()",
                            },
                            model: {
                              value: _vm.form.wbillNo,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "wbillNo", $$v)
                              },
                              expression: "form.wbillNo",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 14 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "agreementNo",
                            label: _vm.$t("home.agreementNo"),
                          },
                        },
                        [
                          _c("el-input", {
                            directives: [
                              {
                                name: "byte-length",
                                rawName: "v-byte-length",
                                value: 50,
                                expression: "50",
                              },
                              { name: "uppercase", rawName: "v-uppercase" },
                              { name: "trim", rawName: "v-trim" },
                              { name: "fth", rawName: "v-fth" },
                            ],
                            attrs: {
                              onblur: "this.value = this.value.toUpperCase()",
                            },
                            model: {
                              value: _vm.form.agreementNo,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "agreementNo", $$v)
                              },
                              expression: "form.agreementNo",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "reqired",
                          attrs: {
                            prop: "freeTimeNo",
                            label: _vm.$t("home.ft"),
                          },
                        },
                        [
                          _c("el-input", {
                            directives: [
                              {
                                name: "byte-length",
                                rawName: "v-byte-length",
                                value: 50,
                                expression: "50",
                              },
                              { name: "uppercase", rawName: "v-uppercase" },
                              { name: "trim", rawName: "v-trim" },
                              { name: "fth", rawName: "v-fth" },
                            ],
                            attrs: {
                              onblur: "this.value = this.value.toUpperCase()",
                              disabled: _vm.preLockFlag,
                            },
                            model: {
                              value: _vm.form.freeTimeNo,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "freeTimeNo", $$v)
                              },
                              expression: "form.freeTimeNo",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "stuffType",
                            label: _vm.$t("home.stuffType"),
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                clearable: "",
                                disabled: _vm.preLockFlag,
                              },
                              model: {
                                value: _vm.form.stuffType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "stuffType", $$v)
                                },
                                expression: "form.stuffType",
                              },
                            },
                            _vm._l(_vm.stuffTypeList, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.name, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "cargoType",
                            label: _vm.$t("home.cargoType"),
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                clearable: "",
                                disabled: _vm.preLockFlag,
                              },
                              model: {
                                value: _vm.form.expCustomsCargoType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "expCustomsCargoType", $$v)
                                },
                                expression: "form.expCustomsCargoType",
                              },
                            },
                            _vm._l(_vm.cargoListType, function (item) {
                              return _c("el-option", {
                                key: item.code,
                                attrs: { label: item.name, value: item.code },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 14 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { prop: "sales", label: _vm.$t("home.sales") },
                        },
                        [
                          _c("el-input", {
                            directives: [
                              { name: "uppercase", rawName: "v-uppercase" },
                              { name: "trim", rawName: "v-trim" },
                              { name: "fth", rawName: "v-fth" },
                              {
                                name: "byte-length",
                                rawName: "v-byte-length",
                                value: 50,
                                expression: "50",
                              },
                            ],
                            attrs: {
                              disabled: !(
                                _vm.form.pol && _vm.form.pol.startsWith("TH")
                              ),
                              onblur: "this.value = this.value.toUpperCase()",
                            },
                            model: {
                              value: _vm.form.sales,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "sales", $$v)
                              },
                              expression: "form.sales",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 14 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "reqired",
                          attrs: { prop: "por", label: _vm.$t("home.por") },
                        },
                        [
                          _c("glPort", {
                            attrs: { disabled: _vm.preLockFlag },
                            on: { change: _vm.changePor },
                            model: {
                              value: _vm.form.por,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "por", $$v)
                              },
                              expression: "form.por",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "reqired",
                          attrs: { prop: "pol", label: _vm.$t("home.pol") },
                        },
                        [
                          _c("glPort", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.form.pol,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "pol", $$v)
                              },
                              expression: "form.pol",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "reqired",
                          attrs: { prop: "pod", label: _vm.$t("home.pod") },
                        },
                        [
                          _c("glPort", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.form.pod,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "pod", $$v)
                              },
                              expression: "form.pod",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "reqired",
                          attrs: { prop: "del", label: _vm.$t("home.del") },
                        },
                        [
                          _c("glPort", {
                            attrs: { disabled: _vm.preLockFlag },
                            on: { change: _vm.changeDel },
                            model: {
                              value: _vm.form.del,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "del", $$v)
                              },
                              expression: "form.del",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                {
                  staticStyle: { "margin-top": "10px" },
                  attrs: { gutter: 14 },
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { staticClass: "reqired", attrs: { prop: "porName" } },
                        [
                          _c("el-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.form.porName,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "porName", $$v)
                              },
                              expression: "form.porName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { staticClass: "reqired", attrs: { prop: "polName" } },
                        [
                          _c("el-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.form.polName,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "polName", $$v)
                              },
                              expression: "form.polName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { staticClass: "reqired", attrs: { prop: "podName" } },
                        [
                          _c("el-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.form.podName,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "podName", $$v)
                              },
                              expression: "form.podName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { staticClass: "reqired", attrs: { prop: "delName" } },
                        [
                          _c("el-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.form.delName,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "delName", $$v)
                              },
                              expression: "form.delName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-checkbox",
                {
                  attrs: {
                    "true-label": 1,
                    "false-label": 0,
                    disabled: _vm.preLockFlag,
                  },
                  model: {
                    value: _vm.form.vipFlag,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "vipFlag", $$v)
                    },
                    expression: "form.vipFlag",
                  },
                },
                [_vm._v("VIP")]
              ),
              _vm._v(" "),
              _c(
                "el-checkbox",
                {
                  attrs: {
                    "true-label": 1,
                    "false-label": 0,
                    disabled: _vm.preLockFlag,
                  },
                  model: {
                    value: _vm.form.masterBlFlag,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "masterBlFlag", $$v)
                    },
                    expression: "form.masterBlFlag",
                  },
                },
                [_vm._v("NVOCC")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          !_vm.showDisplay
            ? _c(
                "div",
                {
                  staticClass: "filter-container-content",
                  staticStyle: { display: "flex", "align-items": "center" },
                  attrs: { id: "consignerInfo" },
                  on: { click: _vm.handleShowDisplay },
                },
                [
                  _c("div", { staticClass: "filter-container-title" }, [
                    _vm._v(_vm._s(_vm.$t("home.displayButton"))),
                  ]),
                  _c("div", { staticClass: "consignerInfo-button" }, [
                    _vm._v(_vm._s(_vm.$t("home.displayOpen"))),
                    _c("i", { staticClass: "el-icon-arrow-down" }),
                  ]),
                ]
              )
            : _c(
                "div",
                {
                  staticClass: "filter-container-content",
                  staticStyle: { display: "flex", "align-items": "center" },
                  attrs: { id: "consignerInfo" },
                  on: { click: _vm.handleShowDisplay },
                },
                [
                  _c("div", { staticClass: "filter-container-title" }, [
                    _vm._v(_vm._s(_vm.$t("home.hideButton"))),
                  ]),
                  _c(
                    "el-button",
                    {
                      staticClass: "consignerInfo-button",
                      attrs: {
                        disabled:
                          this.form.pol && _vm.form.pol.startsWith("TH"),
                        type: "text",
                      },
                    },
                    [
                      _vm._v(_vm._s(_vm.$t("home.displayClose"))),
                      _c("i", { staticClass: "el-icon-arrow-up" }),
                    ]
                  ),
                ],
                1
              ),
          _vm._v(" "),
          _vm.showDisplay
            ? _c("div", [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "justify-content": "space-between",
                    },
                  },
                  [
                    _c("consignerInfo", {
                      ref: "consignerInfo",
                      staticStyle: { width: "49%" },
                      attrs: {
                        isDisable: this.isDisable,
                        isShowRequired: false,
                        form: _vm.form,
                      },
                    }),
                    _vm._v(" "),
                    _c("consignerReceiveInfo", {
                      ref: "consignerReceiveInfo",
                      staticStyle: { width: "49%" },
                      attrs: {
                        isDisable: this.isDisable,
                        isShowRequired: false,
                        form: _vm.form,
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "justify-content": "space-between",
                    },
                  },
                  [
                    _c("consignerInfoOne", {
                      ref: "consignerInfoOne",
                      staticStyle: { width: "49%" },
                      attrs: {
                        isDisable: this.isDisable,
                        isShowRequired: false,
                        form: _vm.form,
                      },
                    }),
                    _vm._v(" "),
                    _c("consignerInfoTwo", {
                      ref: "consignerInfoTwo",
                      staticStyle: { width: "49%" },
                      attrs: {
                        isDisable: this.isDisable,
                        isShowRequired: false,
                        form: _vm.form,
                      },
                    }),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("bookCargo", {
            ref: "bookCargo",
            attrs: {
              "is-disable": this.isDisable,
              isShow: false,
              showCargoInfo: _vm.showCargoInfo,
              isShowRequired: false,
              id: "cargoInfo",
              formInfo: _vm.form,
              rules: _vm.rules,
              preLockFlag: _vm.preLockFlag,
            },
            on: { openDialog: _vm.openDialog },
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "filter-container-content",
              attrs: { id: "boxInfo" },
            },
            [
              _c(
                "div",
                { staticClass: "filter-container-title" },
                [
                  _c(
                    "div",
                    {
                      staticStyle: { display: "flex", "align-items": "center" },
                    },
                    [
                      _vm._v(_vm._s(_vm.$t("home.dropTitle")) + " "),
                      _c("div", { staticClass: "title-total" }, [
                        _vm._v(
                          _vm._s(_vm.$t("home.total")) +
                            ":" +
                            _vm._s(_vm.total ? _vm.total : "")
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "text",
                        icon: "el-icon-plus",
                        disabled: _vm.preLockFlag || _vm.isDisable,
                      },
                      on: { click: _vm.handleAddBox },
                    },
                    [_vm._v(_vm._s(_vm.$t("home.dropTitle")))]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "table-container-new-back" },
                [
                  _c(
                    "el-table",
                    {
                      ref: "multipleTable",
                      attrs: { data: _vm.form.webBkPreContainerComs },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          type: "index",
                          label: _vm.$t("home.No"),
                          width: "60",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "el-table-column",
                        {
                          attrs: { prop: "containerType" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop:
                                          "webBkPreContainerComs." +
                                          scope.$index +
                                          ".containerType",
                                        rules: _vm.rules.containerType,
                                      },
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          attrs: { disabled: _vm.preLockFlag },
                                          model: {
                                            value: scope.row.containerType,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "containerType",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "scope.row.containerType",
                                          },
                                        },
                                        _vm._l(
                                          _vm.containerTypeList,
                                          function (item, index) {
                                            return _c("el-option", {
                                              key: index,
                                              attrs: {
                                                label: String(item),
                                                value: item,
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                        },
                        [
                          _c("template", { slot: "header" }, [
                            _c("span", { staticClass: "required-marker" }, [
                              _vm._v(" *"),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "required-marker" }, [
                              _vm._v(_vm._s(_vm.$t("home.containerType"))),
                            ]),
                          ]),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "el-table-column",
                        {
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop:
                                          "webBkPreContainerComs." +
                                          scope.$index +
                                          ".quantity",
                                        rules: _vm.rules.quantity,
                                      },
                                    },
                                    [
                                      _c("el-input-number", {
                                        attrs: {
                                          precision: 0,
                                          disabled:
                                            _vm.form.singleContainerFlag == 1 ||
                                            _vm.preLockFlag,
                                          "auto-cut": true,
                                          controls: false,
                                          max: 9999999,
                                        },
                                        model: {
                                          value: scope.row.quantity,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "quantity",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "scope.row.quantity",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                        },
                        [
                          _c("template", { slot: "header" }, [
                            _c("span", { staticClass: "required-marker" }, [
                              _vm._v(" *"),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "required-marker" }, [
                              _vm._v(_vm._s(_vm.$t("home.quantity"))),
                            ]),
                          ]),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "el-table-column",
                        {
                          attrs: { prop: "cargoTypeCode" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop:
                                          "webBkPreContainerComs." +
                                          scope.$index +
                                          ".cargoTypeCode",
                                        rules: _vm.rules.cargoTypeCode,
                                      },
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          attrs: { disabled: _vm.preLockFlag },
                                          model: {
                                            value: scope.row.cargoTypeCode,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "cargoTypeCode",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "scope.row.cargoTypeCode",
                                          },
                                        },
                                        _vm._l(_vm.cargoList, function (item) {
                                          return _c("el-option", {
                                            key: item.code,
                                            attrs: {
                                              label:
                                                _vm.language === "zh"
                                                  ? item.nameCn
                                                  : item.name,
                                              value: item.code,
                                            },
                                          })
                                        }),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                        },
                        [
                          _c("template", { slot: "header" }, [
                            _c("span", { staticClass: "required-marker" }, [
                              _vm._v(" *"),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "required-marker" }, [
                              _vm._v(_vm._s(_vm.$t("home.cargoTypeCodeOne"))),
                            ]),
                          ]),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "pickUpDate",
                          label: _vm.$t("home.pickUpDate"),
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-form-item",
                                  [
                                    _c("el-date-picker", {
                                      attrs: {
                                        "picker-options": _vm.pickerOptions,
                                        "value-format": "yyyy-MM-dd HH:mm:ss",
                                        type: "date",
                                        disabled: _vm.preLockFlag,
                                      },
                                      model: {
                                        value: scope.row.pickUpDate,
                                        callback: function ($$v) {
                                          _vm.$set(scope.row, "pickUpDate", $$v)
                                        },
                                        expression: "scope.row.pickUpDate",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "returnDate",
                          label: _vm.$t("home.retureDate"),
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-form-item",
                                  [
                                    _c("el-date-picker", {
                                      attrs: {
                                        "picker-options": _vm.pickerOptions,
                                        "value-format": "yyyy-MM-dd HH:mm:ss",
                                        type: "date",
                                        disabled: _vm.preLockFlag,
                                      },
                                      model: {
                                        value: scope.row.returnDate,
                                        callback: function ($$v) {
                                          _vm.$set(scope.row, "returnDate", $$v)
                                        },
                                        expression: "scope.row.returnDate",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: _vm.$t("home.pickUpDepot") },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-form-item",
                                  [
                                    _c("glPortFacility", {
                                      attrs: { disabled: _vm.preLockFlag },
                                      model: {
                                        value: scope.row.pickUpDepot,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            scope.row,
                                            "pickUpDepot",
                                            $$v
                                          )
                                        },
                                        expression: "scope.row.pickUpDepot",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: _vm.$t("home.returnDepot") },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-form-item",
                                  [
                                    _c("glPortFacility", {
                                      attrs: { disabled: _vm.preLockFlag },
                                      model: {
                                        value: scope.row.returnDepot,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            scope.row,
                                            "returnDepot",
                                            $$v
                                          )
                                        },
                                        expression: "scope.row.returnDepot",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return scope.$index !== 0
                                  ? [
                                      _c("i", {
                                        staticClass: "el-icon-remove-outline",
                                        attrs: {
                                          hidden:
                                            _vm.preLockFlag || _vm.isDisable,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleRemoveBox(
                                              scope.row,
                                              scope.$index
                                            )
                                          },
                                        },
                                      }),
                                    ]
                                  : undefined
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "filter-container-content",
              attrs: { id: "otherInfo" },
            },
            [
              _c("div", { staticClass: "filter-container-title" }, [
                _c("div", [_vm._v(_vm._s(_vm.$t("home.terminalInfo")))]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "table-container-new-back" },
                [
                  !_vm.isShowContent
                    ? _c(
                        "el-table",
                        {
                          ref: "multipleTable",
                          attrs: { data: _vm.form.webBkYardComs },
                        },
                        [
                          _c(
                            "el-table-column",
                            {
                              attrs: { prop: "pickupYard" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          { attrs: { prop: "pickupYard" } },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                attrs: {
                                                  filterable: "",
                                                  disabled:
                                                    _vm.preLockFlag ||
                                                    _vm.form.pol === "CNSHK" ||
                                                    _vm.form.pol === "CNNSA",
                                                  clearable: "",
                                                },
                                                on: {
                                                  focus: function ($event) {
                                                    return _vm.changePickupYard(
                                                      scope.$index
                                                    )
                                                  },
                                                  change: function ($event) {
                                                    return _vm.handlePickupYard()
                                                  },
                                                },
                                                model: {
                                                  value: scope.row.pickupYard,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "pickupYard",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.pickupYard",
                                                },
                                              },
                                              _vm._l(
                                                _vm.dataList,
                                                function (item) {
                                                  return _c("el-option", {
                                                    key: item.facilityCode,
                                                    attrs: {
                                                      label:
                                                        _vm.language === "zh"
                                                          ? item.facilityNameCn
                                                          : item.facilityName,
                                                      value: item.facilityCode,
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                1247642867
                              ),
                            },
                            [
                              _vm.form.pol == "CNTAO"
                                ? _c("template", { slot: "header" }, [
                                    _c(
                                      "span",
                                      { staticClass: "required-marker" },
                                      [_vm._v(" *")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "required-marker" },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("home.pickupYard"))
                                        ),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.form.pol !== "CNTAO"
                                ? _c("template", { slot: "header" }, [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$t("home.pickupYard"))),
                                    ]),
                                  ])
                                : _vm._e(),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "el-table-column",
                            {
                              attrs: { prop: "returnYard" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          { attrs: { prop: "returnYard" } },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                attrs: {
                                                  filterable: "",
                                                  clearable: "",
                                                  disabled: _vm.preLockFlag,
                                                },
                                                model: {
                                                  value: scope.row.returnYard,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "returnYard",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.returnYard",
                                                },
                                              },
                                              _vm._l(
                                                _vm.dataList,
                                                function (item) {
                                                  return _c("el-option", {
                                                    key: item.facilityCode,
                                                    attrs: {
                                                      label:
                                                        _vm.language === "zh"
                                                          ? item.facilityNameCn
                                                          : item.facilityName,
                                                      value: item.facilityCode,
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                916430650
                              ),
                            },
                            [
                              _vm.form.pol == "CNTAO"
                                ? _c("template", { slot: "header" }, [
                                    _c(
                                      "span",
                                      { staticClass: "required-marker" },
                                      [_vm._v(" *")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "required-marker" },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("home.returnYard"))
                                        ),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.form.pol !== "CNTAO"
                                ? _c("template", { slot: "header" }, [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$t("home.returnYard"))),
                                    ]),
                                  ])
                                : _vm._e(),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "el-table-column",
                            {
                              attrs: { prop: "pickupDate" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          { attrs: { prop: "pickupDate" } },
                                          [
                                            _c("el-date-picker", {
                                              attrs: {
                                                "picker-options":
                                                  _vm.pickerOptions,
                                                "value-format":
                                                  "yyyy-MM-dd HH:mm:ss",
                                                type: "date",
                                                disabled: _vm.preLockFlag,
                                              },
                                              model: {
                                                value: scope.row.pickupDate,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "pickupDate",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.pickupDate",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                93982553
                              ),
                            },
                            [
                              _c("template", { slot: "header" }, [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("home.pickUpDate"))),
                                ]),
                              ]),
                            ],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticStyle: { display: "flex" } }, [
            _c(
              "div",
              {
                staticClass: "filter-container-content",
                staticStyle: { width: "35%" },
              },
              [
                _c(
                  "div",
                  { staticClass: "filter-container-title" },
                  [
                    _c("div", [
                      _vm._v(_vm._s(_vm.$t("home.additionalCharges"))),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "text",
                          icon: "el-icon-plus",
                          disabled: _vm.preLockFlag || _vm.isDisable,
                        },
                        on: { click: _vm.handleAddCharge },
                      },
                      [_vm._v(_vm._s(_vm.$t("home.additionalCharges")))]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "table-container-new-back" },
                  [
                    _c(
                      "el-table",
                      {
                        ref: "multipleTable",
                        attrs: { data: _vm.form.webFeeItemComs },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "feeItem",
                            label: _vm.$t("home.feeItem"),
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    [
                                      _c("el-input", {
                                        directives: [
                                          {
                                            name: "uppercase",
                                            rawName: "v-uppercase",
                                          },
                                          { name: "trim", rawName: "v-trim" },
                                          { name: "fth", rawName: "v-fth" },
                                        ],
                                        attrs: {
                                          onblur:
                                            "this.value = this.value.toUpperCase()",
                                          size: "small",
                                          disabled: _vm.preLockFlag,
                                        },
                                        model: {
                                          value: scope.row.feeItem,
                                          callback: function ($$v) {
                                            _vm.$set(scope.row, "feeItem", $$v)
                                          },
                                          expression: "scope.row.feeItem",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "payModel",
                            label: _vm.$t("home.payModel"),
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          attrs: {
                                            clearable: "",
                                            disabled: _vm.preLockFlag,
                                          },
                                          model: {
                                            value: scope.row.payModel,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "payModel",
                                                $$v
                                              )
                                            },
                                            expression: "scope.row.payModel",
                                          },
                                        },
                                        _vm._l(
                                          _vm.paidTypeList,
                                          function (item) {
                                            return _c("el-option", {
                                              key: item.codeValue,
                                              attrs: {
                                                label:
                                                  _vm.language === "zh"
                                                    ? item.displayValueCn
                                                    : item.displayValue,
                                                value: Number(item.codeValue),
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: { width: "40px" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("i", {
                                    staticClass: "el-icon-remove-outline",
                                    attrs: {
                                      hidden: _vm.preLockFlag || _vm.isDisable,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleRemoveCharge(
                                          scope.row,
                                          scope.$index
                                        )
                                      },
                                    },
                                  }),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "filter-container-content",
                staticStyle: { width: "65%" },
              },
              [
                _c(
                  "div",
                  { staticClass: "filter-container-title" },
                  [
                    _c("div", [_vm._v("BK Document")]),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "text",
                          icon: "el-icon-plus",
                          disabled: _vm.preLockFlag || _vm.isDisable,
                        },
                        on: { click: _vm.handleAddChargeBk },
                      },
                      [_vm._v("BK Document")]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "table-container-new-back" },
                  [
                    !_vm.isShowContent
                      ? _c(
                          "el-table",
                          {
                            ref: "multipleTable",
                            attrs: { data: _vm.form.webBkDocumentComs },
                          },
                          [
                            _c(
                              "el-table-column",
                              {
                                attrs: { prop: "documentNo" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                prop:
                                                  "webBkDocumentComs." +
                                                  scope.$index +
                                                  ".documentNo",
                                                rules: _vm.rules.documentNo,
                                              },
                                            },
                                            [
                                              _c("el-input", {
                                                directives: [
                                                  {
                                                    name: "uppercase",
                                                    rawName: "v-uppercase",
                                                  },
                                                  {
                                                    name: "trim",
                                                    rawName: "v-trim",
                                                  },
                                                  {
                                                    name: "fth",
                                                    rawName: "v-fth",
                                                  },
                                                ],
                                                attrs: {
                                                  size: "small",
                                                  onblur:
                                                    "this.value = this.value.toUpperCase()",
                                                  disabled: _vm.preLockFlag,
                                                },
                                                model: {
                                                  value: scope.row.documentNo,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "documentNo",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.documentNo",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2559995906
                                ),
                              },
                              [
                                _vm.isShowDocumentNo
                                  ? _c("template", { slot: "header" }, [
                                      _c(
                                        "span",
                                        { staticClass: "required-marker" },
                                        [_vm._v(" *")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "required-marker" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("home.documentNoNew"))
                                          ),
                                        ]
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.isShowDocumentNo
                                  ? _c("template", { slot: "header" }, [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.$t("home.documentNoNew"))
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "packageCount",
                                label: _vm.$t("home.packageCount"),
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          [
                                            _c("el-input-number", {
                                              attrs: {
                                                precision: 0,
                                                "auto-cut": true,
                                                controls: false,
                                                max: 9999999,
                                                disabled: _vm.preLockFlag,
                                              },
                                              model: {
                                                value: scope.row.packageCount,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "packageCount",
                                                    typeof $$v === "string"
                                                      ? $$v.trim()
                                                      : $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.packageCount",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                4012802912
                              ),
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "packageType",
                                label: _vm.$t("home.packageType"),
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                attrs: {
                                                  clearable: "",
                                                  disabled: _vm.preLockFlag,
                                                },
                                                model: {
                                                  value: scope.row.packageType,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "packageType",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.packageType",
                                                },
                                              },
                                              _vm._l(
                                                _vm.form.pol.startsWith("KR")
                                                  ? _vm.packageTypeListKR
                                                  : _vm.packageTypeList,
                                                function (item) {
                                                  return _c("el-option", {
                                                    key: item.packageCode,
                                                    attrs: {
                                                      label:
                                                        _vm.language === "zh"
                                                          ? item.packageNameCn
                                                          : item.packageName,
                                                      value: item.packageCode,
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                3194850902
                              ),
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "weight",
                                label: _vm.$t("home.weight"),
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          [
                                            _c("el-input-number", {
                                              attrs: {
                                                precision: 3,
                                                "auto-cut": true,
                                                controls: false,
                                                max: 99999999999999.999,
                                                disabled: _vm.preLockFlag,
                                              },
                                              model: {
                                                value: scope.row.weight,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "weight",
                                                    typeof $$v === "string"
                                                      ? $$v.trim()
                                                      : $$v
                                                  )
                                                },
                                                expression: "scope.row.weight",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                3256873588
                              ),
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "isSplit",
                                label: _vm.$t("home.isSplit"),
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                attrs: {
                                                  clearable: "",
                                                  disabled: _vm.preLockFlag,
                                                },
                                                model: {
                                                  value: scope.row.isSplit,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "isSplit",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.isSplit",
                                                },
                                              },
                                              _vm._l(
                                                _vm.isSplitList,
                                                function (item) {
                                                  return _c("el-option", {
                                                    key: item.value,
                                                    attrs: {
                                                      label:
                                                        _vm.language === "zh"
                                                          ? item.labelZh
                                                          : item.labelEh,
                                                      value: item.value,
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                811211701
                              ),
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "useTimes",
                                label: _vm.$t("home.useTimes"),
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          [
                                            _c("el-input-number", {
                                              attrs: {
                                                precision: 0,
                                                "auto-cut": true,
                                                controls: false,
                                                max: 9999999,
                                                disabled: _vm.preLockFlag,
                                              },
                                              model: {
                                                value: scope.row.useTimes,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "useTimes",
                                                    typeof $$v === "string"
                                                      ? $$v.trim()
                                                      : $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.useTimes",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                1836115580
                              ),
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: { width: "40px" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("i", {
                                          staticClass: "el-icon-remove-outline",
                                          attrs: {
                                            hidden:
                                              _vm.preLockFlag || _vm.isDisable,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleRemoveBk(
                                                scope.row,
                                                scope.$index
                                              )
                                            },
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                1890560599
                              ),
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("bookInfo", {
            ref: "bookInfo",
            attrs: {
              isDisable: _vm.isDisable,
              showdisabled: _vm.isDisable,
              isSupplyDisabled: _vm.isDisable,
              copy: _vm.isCopy,
              form: _vm.form,
              rules: _vm.rules,
              containerSizeList: _vm.containerSizeList,
              containerTypeList: _vm.containerTypeList,
              lineTypeList: _vm.lineTypeList,
              directionList: _vm.directionList,
              packageTypeList: _vm.packageTypeList,
              packageDescList: _vm.packageDescList,
              contactTypeCodeList: _vm.contactTypeCodeList,
              fullEmptyTypeList: _vm.fullEmptyTypeList,
              preLockFlag: _vm.preLockFlag,
              adjustVesselFlag: _vm.adjustVesselFlag,
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "filter-container-content" },
            [
              _c(
                "el-row",
                { attrs: { gutter: 14 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          class: {
                            reqired:
                              _vm.form.pol && _vm.form.pol.startsWith("KR"),
                          },
                          attrs: {
                            prop: "remark",
                            label: _vm.$t("home.remark"),
                          },
                        },
                        [
                          _c("el-input", {
                            directives: [
                              {
                                name: "byte-length",
                                rawName: "v-byte-length",
                                value: 2000,
                                expression: "2000",
                              },
                              { name: "uppercase", rawName: "v-uppercase" },
                              { name: "trim", rawName: "v-trim" },
                              { name: "fth", rawName: "v-fth" },
                            ],
                            attrs: {
                              type: "textarea",
                              onblur:
                                "this.value = this.value.toUpperCase().trim().replace(/[ \\t]*(\\n|\\r\\n)[ \\t]*/g, '$1')",
                              autosize: { minRows: 3, maxRows: 5 },
                              disabled: _vm.preLockFlag,
                            },
                            nativeOn: {
                              dblclick: function ($event) {
                                return _vm.openDialog(_vm.form.remark, 3, 2000)
                              },
                            },
                            model: {
                              value: _vm.form.remark,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "remark", $$v)
                              },
                              expression: "form.remark",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          class: {
                            reqired:
                              _vm.form.pol &&
                              (_vm.form.pol === "CNSHK" ||
                                _vm.form.pol === "CNNSA"),
                          },
                          attrs: {
                            prop: "priceRemark",
                            label: _vm.$t("home.priceRemark"),
                          },
                        },
                        [
                          _c("el-input", {
                            directives: [
                              {
                                name: "byte-length",
                                rawName: "v-byte-length",
                                value: 500,
                                expression: "500",
                              },
                              { name: "uppercase", rawName: "v-uppercase" },
                              { name: "trim", rawName: "v-trim" },
                              { name: "fth", rawName: "v-fth" },
                            ],
                            attrs: {
                              type: "textarea",
                              onblur:
                                "this.value = this.value.toUpperCase().trim().replace(/[ \\t]*(\\n|\\r\\n)[ \\t]*/g, '$1')",
                              placeholder:
                                _vm.form.pol &&
                                (_vm.form.pol === "CNSHK" ||
                                  _vm.form.pol === "CNNSA")
                                  ? _vm.$t("home.priceRemarkInfo")
                                  : "",
                              autosize: { minRows: 3, maxRows: 5 },
                              disabled: _vm.preLockFlag,
                            },
                            nativeOn: {
                              dblclick: function ($event) {
                                return _vm.openDialog(
                                  _vm.form.priceRemark,
                                  4,
                                  500
                                )
                              },
                            },
                            model: {
                              value: _vm.form.priceRemark,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "priceRemark", $$v)
                              },
                              expression: "form.priceRemark",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "bottom-button",
          staticStyle: {
            height: "50px",
            "line-height": "50px",
            background: "#fff",
            "padding-left": "20px",
          },
        },
        [
          _vm.isCanSave || this.isCopy == "copy"
            ? _c(
                "el-button",
                {
                  staticClass: "btn-primary",
                  attrs: { type: "primary", disabled: _vm.isDisable },
                  on: {
                    click: function ($event) {
                      return _vm.handleSave(11)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("home.buttonAdd")))]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isCanSaveDraft || this.isCopy == "copy"
            ? _c(
                "el-button",
                {
                  staticClass: "btn-plain-primary",
                  on: { click: _vm.handleSaveDraft },
                },
                [_vm._v(_vm._s(_vm.$t("home.buttonSaveCopy")))]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.bookingId && _vm.isCanSaveCopy
            ? _c(
                "el-button",
                {
                  staticClass: "btn-plain-primary",
                  on: { click: _vm.handleCopy },
                },
                [_vm._v(_vm._s(_vm.$t("home.buttonCopy")))]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "btn-plain-primary",
              on: { click: _vm.handleCloseLast },
            },
            [_vm._v(_vm._s(_vm.$t("home.close")))]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("copyBook", {
        ref: "copyBook",
        attrs: {
          width: "40%",
          pol: _vm.form.pol,
          copyId: _vm.copyId,
          visible: _vm.copyVisible,
        },
        on: {
          "update:visible": function ($event) {
            _vm.copyVisible = $event
          },
        },
      }),
      _vm._v(" "),
      _c("sailSchedule", {
        ref: "sailSchedule",
        attrs: {
          "destroy-on-close": true,
          width: "70%",
          isSelectVessel: true,
          visible: _vm.sailScheduleDialogVisible,
        },
        on: {
          selectionChange: _vm.selectionChange,
          "update:visible": function ($event) {
            _vm.sailScheduleDialogVisible = $event
          },
        },
      }),
      _vm._v(" "),
      _vm.showDialog
        ? _c("message-input-text", {
            key: "123",
            ref: "myDialog",
            attrs: { catalogContent: _vm.dialogContent },
            on: {
              "update:catalogContent": function ($event) {
                _vm.dialogContent = $event
              },
              "update:catalog-content": function ($event) {
                _vm.dialogContent = $event
              },
              confirmClose: _vm.confirmClose,
              confirm: _vm.confirm,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }